// Frontend API Configuration
// The frontend will communicate with the backend API, not directly with Supabase

// Prefer env var; otherwise default to same-origin `/api` to avoid CORS/mixed-content in dev & prod.
// Final fallback is the hosted API over HTTPS.
const computeApiBaseUrl = (): string => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && fromEnv.trim().length > 0) {
    return fromEnv.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}/api`;
  }

  return 'https://temple-api.gfat.augmont.com/api';
};

export const API_BASE_URL = computeApiBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  // Database operations
  db: {
    test: `${API_BASE_URL}/db/test`,
    tables: `${API_BASE_URL}/db/tables`,
    table: (tableName: string) => `${API_BASE_URL}/db/${tableName}`,
    record: (tableName: string, id: string | number) => `${API_BASE_URL}/db/${tableName}/${id}`,
  },
  // Health check
  health: `${API_BASE_URL}/health`,
  // Sample data
  data: `${API_BASE_URL}/data`,
};

// Response types
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
  details?: any;
  message?: string; // For OTP responses
  otp?: string; // For testing purposes
} 